import type {
  BoxesBreadcrumbContent,
  BoxesTitleContent,
} from "@loot-os/design-system/templates/boxes/boxesContent";
import { useCatalogCopy } from "./copy.js";

/** Where the boxes page sits: under the home page. */
export function useBoxesBreadcrumbContent(): BoxesBreadcrumbContent {
  const copy = useCatalogCopy();
  return { trail: [{ label: copy.breadcrumb.home, href: "/" }], current: copy.title };
}

/** The page's heading, in the store's word for its boxes. */
export function useBoxesTitleContent(): BoxesTitleContent {
  return { text: useCatalogCopy().title };
}
